import {
  selectIsConnected,
  selectMatsnetUserRank,
  selectMatsnetUsersCount,
  useDappSelector,
} from "#/redux-state"
import { useMatsnetLeaderboardRank } from "#/shared/hooks"
import { separateThousandsWithComaRegExp } from "#/shared/utils"

import { StatsCard, StatsSatsRankCard } from "../Stats"

import LeaderboardStatsWrapper from "./LeaderboardStatsWrapper"
import LeaderboardTrophy from "./LeaderboardTrophy"

export default function LeaderboardSatsStats() {
  const numberOfRankedUsers = useDappSelector(selectMatsnetUsersCount)
  const isConnected = useDappSelector(selectIsConnected)

  const { rank } = useDappSelector(selectMatsnetUserRank)
  const rankData = useMatsnetLeaderboardRank()

  return (
    <LeaderboardStatsWrapper
      stats={[
        {
          key: "rank",
          children:
            isConnected && rank ? (
              <StatsSatsRankCard
                label={<LeaderboardTrophy rank={rankData} />}
              />
            ) : null,
        },
        {
          key: "users",
          children: (
            <StatsCard
              value={`${separateThousandsWithComaRegExp(
                numberOfRankedUsers.toString(),
              )}`}
              title="Total ranked users"
            />
          ),
        },
      ]}
    />
  )
}
